import * as types from "../../constants/actionTypes";
import initialState from "./initialState";

export function queueRequests(state = initialState.queueRequests, action) {
  switch (action.type) {
    case types.FETCH_MYQUEUEREQUESTS_SUCCESS:
      return [...state, action.returnRequests];

    default:
      return state;
  }
}

export function queueRequestsSelected(state = initialState.queueRequestsSelected, action) {
  switch (action.type) {
    case types.TOGGLE_QUEUE_REQUEST: {
      let foundItem = state.filter((item) => item.key === action.id);

      if (Object.keys(foundItem).length > 0) {
        return state.filter((item) => item.key !== action.id);
      }

      return [...state, { key: action.id, value: action.environment }];
    }
    case types.FETCH_MYQUEUEREQUESTS_SUCCESS:
    case types.CANCEL_QUEUE_REQUEST_SUCCESS:
    case types.CLEAR_SELECTED_QUEUE_REQUESTS:
      return initialState.queueRequestsSelected;

    default:
      return state;
  }
}
